import { RootState } from 'src/redux/createRootReducer'
import { ErrorDetailMap } from 'src/utils/error.utils'

export const selectIsLookingUpFromState = (state: RootState): boolean =>
  state.app.signin.isLookingUp
export const selectIsSigningInFromState = (state: RootState): boolean =>
  state.app.signin.isSigningIn
export const selectIsVerifyingUserFromState = (state: RootState): boolean =>
  state.app.signin.isVerifyingUser
export const selectUserEmailVerifiedFromState = (state: RootState): boolean =>
  state.app.signin.userEmailVerified
export const selectVerificationEmailResentFromState = (
  state: RootState,
): boolean => state.app.signin.verificationEmailResent
export const selectResendVerificationTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.signin.resendVerificationTopLevelError
export const selectVerifyEmailTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.signin.verifyEmailTopLevelError
export const selectSigninTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.signin.signinTopLevelError
export const selectSigninErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined => state.app.signin.signinErrorDetailMap
export const selectLookupTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.signin.lookupTopLevelError
export const selectLookupErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined => state.app.signin.lookupErrorDetailMap
export const selectVerificationPhoneResentFromState = (
  state: RootState,
): boolean => state.app.signin.verificationPhoneResent
export const selectVerificationPhoneLoadingFromState = (
  state: RootState,
): boolean => state.app.signin.verifyPhoneVerificationLoading
export const selectVerifyPhoneTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.signin.verifyPhoneTopLevelError
